import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Seo from '@/components/base/Seo';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles, siteInfo } from '@/mocks/anime';

export default function Articles() {
  const [feature, ...rest] = articles;
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '新番资讯 - 动漫网',
      url: `${siteInfo.url}/articles`,
      description: '动漫网新番资讯、番剧盘点、经典回顾与补番指南，第一时间掌握二次元动态。',
      inLanguage: 'zh-CN',
    },
  ];

  return (
    <Layout>
      <Seo
        title="新番资讯与补番指南 - 动漫网官网首页"
        description="动漫网新番资讯、番剧盘点、经典回顾与补番指南，第一时间掌握二次元动态。动漫网网址收藏、直达链接、主页导航全都有。"
        path="/articles"
        jsonLd={jsonLd}
      />

      <div className="bg-gradient-to-br from-secondary-100 via-background-100 to-primary-100 pt-24 pb-8">
        <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
          <Breadcrumb items={[{ name: '首页', path: '/' }, { name: '新番资讯' }]} />
          <h1 className="mt-3 font-heading text-3xl text-foreground-950">新番资讯与补番指南</h1>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            新番前瞻、神作盘点、经典回顾、补番指南，帮你更快找到心头好。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-8">
        <Link to={`/article/${feature.id}`} className="group grid overflow-hidden rounded-lg bg-background-100 lg:grid-cols-2">
          <div className="relative aspect-[16/9] w-full overflow-hidden lg:aspect-auto">
            <img
              src={feature.image}
              alt={feature.title}
              title={`${feature.title} - 动漫网`}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-col justify-center p-6 md:p-8">
            <span className="inline-flex w-fit rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">头条推荐</span>
            <h2 className="mt-3 font-heading text-xl leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors md:text-2xl">
              {feature.title}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{feature.summary}</p>
            <p className="mt-4 flex flex-wrap items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1"><i className="ri-user-line" aria-hidden="true" />{feature.author}</span>
              <span className="flex items-center gap-1"><i className="ri-calendar-line" aria-hidden="true" />{feature.date}</span>
              <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{feature.readTime}</span>
              <span className="flex items-center gap-1"><i className="ri-eye-line" aria-hidden="true" />{feature.views}</span>
            </p>
          </div>
        </Link>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((n) => (
            <Link key={n.id} to={`/article/${n.id}`} className="group overflow-hidden rounded-lg bg-background-100">
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  title={`${n.title} - 动漫网`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  {n.categoryName}
                </span>
              </div>
              <div className="p-5">
                <h2 className="font-heading text-base leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {n.title}
                </h2>
                <p className="mt-2 line-clamp-2 text-sm text-foreground-500">{n.summary}</p>
                <p className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-calendar-line" aria-hidden="true" />{n.date}
                  <span>·</span>
                  <i className="ri-eye-line" aria-hidden="true" />{n.views} 阅读
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}